import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import ParticleField from "@/components/ParticleField";
import Navigation from "@/components/Navigation";
import Intro from "@/components/Intro";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import PortalTransition from "@/components/PortalTransition";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Atelier from "@/components/Atelier";
import Portfolio from "@/components/Portfolio";
import Stats from "@/components/Stats";
import Testimonials from "@/components/Testimonials";
import Finale from "@/components/Finale";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { scrolleZu } from "@/lib/scroll";

export default function Experience() {
  const [introDone, setIntroDone] = useState(
    () => sessionStorage.getItem("sf_intro_seen") === "1"
  );
  const location = useLocation();

  useEffect(() => {
    if (!introDone) window.__lenis?.stop();
    else window.__lenis?.start();
  }, [introDone]);

  useEffect(() => {
    if (location.hash && introDone) {
      const t = setTimeout(
        () => scrolleZu(location.hash, { immediate: true }),
        450
      );
      return () => clearTimeout(t);
    }
  }, [location.hash, introDone]);

  const finishIntro = () => {
    sessionStorage.setItem("sf_intro_seen", "1");
    setIntroDone(true);
  };

  return (
    <>
      <ParticleField />
      {/* Dünner Schleier zwischen Partikeln und Inhalt. Die Messung zeigte,
          dass nicht die mittlere Helligkeit das Problem ist, sondern die
          hellen Partikel: dort brach der Kontrast der Schrift auf 2.7 ein.
          Der Schleier nimmt genau diese Spitzen, ohne die Animation zu
          dämpfen - sie bleibt sichtbar, nur eine Spur ruhiger. */}
      <div
        aria-hidden="true"
        data-testid="lesbarkeits-schleier"
        className="pointer-events-none fixed inset-0 z-[1] bg-[#050505]/35"
      />
      <AnimatePresence>
        {!introDone && <Intro onDone={finishIntro} />}
      </AnimatePresence>
      <Navigation introDone={introDone} />
      <main className="relative z-10">
        <Hero started={introDone} />
        <Marquee />
        <PortalTransition
          testId="portal-act-2"
          act="AKT II · DIE REISE"
          title={
            <>
              Durch die digitale{" "}
              <em className="gold-text font-serif-accent normal-case italic">Welt.</em>
            </>
          }
          sub="Von der ersten Idee zum fertigen Erlebnis."
        />
        <Manifesto />
        <Services />
        <Atelier />
        <PortalTransition
          testId="portal-act-3"
          act="AKT III · UNSERE ARBEIT"
          title={
            <>
              Der{" "}
              <em className="gold-text font-serif-accent normal-case italic">Showroom.</em>
            </>
          }
          sub="Treten Sie ein — jede Website ist eine eigene Welt."
        />
        <Portfolio />
        <Stats />
        <Testimonials />
        <PortalTransition
          testId="portal-act-4"
          act="AKT IV · DAS FINALE"
          title={
            <>
              Alles kehrt{" "}
              <em className="gold-text font-serif-accent normal-case italic">zurück.</em>
            </>
          }
          sub="Zur Marke. Zu Ihnen. Zum Anfang von etwas Großem."
        />
        <Finale />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
